var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SingleRideHeader'),_c('b-container',{staticClass:"py-5"},[_c('SingleRideChecklist')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }